<template>
  <list-form @submit.prevent="doSearch" @reset.prevent="doReset">
    <template #search-form>
      <div class="row">
        <vuex-date-range-search-item class="col" label="操作日" bind-from="operated_at_from" bind-to="operated_at_to" />
        <vuex-text-search-item class="col" label="ユーザー名" bind="user_name" />
      </div>
      <div class="row">
        <vuex-select-search-item class="col" label="操作区分" bind="operation_type" 
                                 :options="$constant.OPERATION_TYPE_LIST"
                                 value-key="value"
        />
        <vuex-text-search-item class="col" label="操作内容" bind="api_name" />
      </div>
      <div class="row">
        <vuex-text-search-item class="col" label="ログ名称" bind="name" />
        <vuex-text-search-item class="col" label="ログ内容" bind="value" />
      </div>
    </template>
    <template #table>
      <div v-if="operationLogs.length">
        <plain-table :headers="tableHeaders" :data="tableData" :pagination="paginationStatus" :sort="sortStatus"
                     @change-page="doChangePage" @sort="doSort" :selectable-rows="false"
        />
      </div>
      <danger-alert v-else message="表示する操作ログがありませんでした。" />
    </template>
  </list-form>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ListForm from '@/views/templates/forms/ListForm';
import VuexTextSearchItem from '@/views/molecules/searchItems/VuexTextSearchItem';
import PlainTable from '@/views/molecules/PlainTable';
import DangerAlert from '@/views/atoms/alerts/DangerAlert'
import VuexDateRangeSearchItem from '@/views/molecules/searchItems/VuexDateRangeSearchItem'
import VuexSelectSearchItem from '@/views/molecules/searchItems/VuexSelectSearchItem'

export default {
  name: 'OperationLogList',
  components: {
    ListForm,
    VuexTextSearchItem,
    PlainTable,
    DangerAlert,
    VuexDateRangeSearchItem,
    VuexSelectSearchItem,  
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'operation_log_index'
  },
  inject: [
    '$constant',
  ],
  data() {
    return {
      tableHeaders: [
        { label: '操作日時', column: 'operated_at' },
        { label: 'ユーザー名', column: 'user_name' },
        { label: '操作区分', column: 'operation_type' },
        { label: '操作内容', column: 'api_name' },
        { label: 'ログ名称', column: 'name' },
        { label: 'ログ内容', column: 'value' },
      ],
    }
  },
  computed: {
    ...mapState('operation_log_index', [
      'operationLogs',
      'paginationStatus',
      'sortStatus',
    ]),
    tableData() {
      return this.operationLogs.map(operationLog => ({
        operated_at: operationLog.operated_at,
        user_name: operationLog.user_name,
        operation_type: operationLog.operation_type,
        api_name: operationLog.api_name,
        name: operationLog.name,
        value: operationLog.value,
      }))
    },
  },
  methods: {
    ...mapMutations('operation_log_index', [
      'setSortColumn',
      'setCurrentPage',
      'setPerPage',
      'resetForms',
    ]),
    loadPage() {
      if (this.paginationStatus.per_page === null) {
        this.setPerPage({value: this.$constant.PAGINATION.PER_PAGE});
        this.resetForms();
      }
      return this.$store.dispatch('operation_log_index/load').then(() => {
        this.$root.showFlashMessage();
      }).catch(reason => this.$root.failApi(reason));
    },
    doSearch() {
      this.setCurrentPage({value: 1});
      this.loadPage();
    },
    doReset() {
      this.resetForms();
    },
    doChangePage(page) {
      this.setCurrentPage({value: page});
      this.loadPage();
    },
    doSort(column) {
      this.setSortColumn({column: column});
      this.loadPage();
    },
  }
}
</script>